import { Container, makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
  containerStyles: {
    "&.MuiContainer-root": {
      [theme.breakpoints.down("md")]: {
        paddingLeft: "5px",
        paddingRight: "5px",
      },
    },
  },
}));
function MainContainer(props) {
  const classes = useStyles();
  return (
    <Container width="sm" className={classes.containerStyles}>
      {props.children}
    </Container>
  );
}

export default MainContainer;
